export default __webpack_public_path__ + "static/media/RPL.17b7883d.png";